<template lang="pug">
#app
  //- .warning-banner(v-if="showWarningMessage")
    .container 
      b Important: 
      u  We do not charge for listings!
      span  beware of fake scam Instagram or Telegram channels, asking for listing fees.
    .close-message(@click="closeListingWarningMessage")
      i.fa.fa-times
  section.hero.is-fullheight
    .hero-body.is-flex-start
      .container
        logo-stats
        top-bar(@go="goTo")
        br
        router-view(:key="keyGenerated")
</template>

<script>
import { apiGet } from './util/general'
import LogoStats from './components/c_logo_stats'
import TopBar from './components/c_top_bar'
export default {
  name: 'app',
  data() {
    return {
      keyGenerated: 0
    }
  },
  components: {
    LogoStats,
    TopBar
  },
  computed: {
    coin() {
      return this.$store.getters.coinSymbol
    },
    pageSelected() {
      return this.$store.getters.pageSelected
    },
    mode() {
      return this.$store.getters.mode
    },
    showWarningMessage() {
      return this.$store.getters.showWarningMessage
    },
    warningMessageTime() {
      return this.$store.getters.warningMessageTime
    }
  },
  created() {
    var vm = this
    vm.toggleWarning()
    vm.migrateLocalStorage()
    vm.initializeCoin()
    vm.initializeGlobalTotals()
    vm.$store.dispatch('validateVersion')
    vm.setReferralCode()
    vm.initializeMode()
  },
  mounted() {
  },
  methods: {
    toggleWarning () {
      var vm = this
      let warningMessageTime = vm.warningMessageTime
      let oneMonthDate = window.dayjs().subtract(30, 'days').valueOf()
      if (warningMessageTime < oneMonthDate) {
        vm.$store.dispatch('setShowWarningMessage', true)
      }
    },
    migrateLocalStorage () {
      let vm = this
      let migrated = localStorage.getItem('migrated');
      if (!migrated) {
        let liveFilterFromLS = localStorage.getItem('live_filter')
        let liveFilter = []
        if (liveFilterFromLS) liveFilter = liveFilterFromLS.split(',')
        vm.$store.dispatch('setLiveFilter', liveFilter)
        vm.$store.dispatch('setRef', localStorage.getItem('ref') || '')
        vm.$store.dispatch('setLastNewsDate', localStorage.getItem('last_news_date') || '1669667290000')
        vm.$store.dispatch('setVersion', localStorage.getItem('version') || '')
        vm.$store.dispatch('setLastCoins', JSON.parse(localStorage.getItem('last_coins_list') || '[]'))
        vm.$store.dispatch('setLastAlgorithms', JSON.parse(localStorage.getItem('last_algorithms_list') || '[]'))
        let addressHistory = [];
        for (let i = 0; i < localStorage.length; i++) {
          let key = localStorage.key(i)
          let data = localStorage.getItem(key)
          if (key.startsWith('last_address')) {
            let coin = key.split('_')[2] || 'TRX';
            if (coin === 'NANO') coin = 'XNO';
            let addresses = data.split(',');
            let coinObj = { coin, last_viewed: +new Date(), addresses: [] }
            for (let item of addresses) {
              coinObj.addresses.push({
                address: item,
                last_viewed: +new Date()
              })
            }
            addressHistory.push(coinObj)
          }
        }
        vm.$store.dispatch('setAddressHistory', addressHistory)
        if (localStorage.getItem('coin')) {
          vm.$store.dispatch('setCoin', { coin: localStorage.getItem('coin') })
        }
        localStorage.setItem('migrated', 'OK');
        console.log('Migration completed!')
      }
    },
    goTo(path) {
      let vm = this
      vm.keyGenerated++
      vm.$router.push(path)
    },
    initializeGlobalTotals() {
      var vm = this
      var url = '/v5/pool'
      var obj = {}
      apiGet(vm, url, obj, function (data) {
        let summary = data.data.summary
        vm.$store.dispatch('manuallySetGloballyTotals', { totalWorkers: summary.past_24hr_workers, totalPaid: summary.total_paid_btc, totalMiners: summary.past_24hr_miners })
      }, function (err) {
        console.error('Error:', err.message)
      })
    },
    initializeCoin() {
    },
    setReferralCode() {
      let vm = this
      let ref = vm.$route.query.ref
      if (ref) {
        vm.$store.dispatch('setRef', ref)
      }
    },
    initializeMode() {
      let vm = this
      if (vm.mode === 'dark') {
        document.querySelector('html').classList.add('dark');
      } else {
        document.querySelector('html').classList.remove('dark');
      }
    },
    closeListingWarningMessage() {
      let vm = this
      let time = (new Date()).getTime()
      vm.$store.dispatch('setWarningMessageTime', time)
      vm.$store.dispatch('setShowWarningMessage', false)
      vm.$nextTick(() => {
        // For sticky positions
        window.dispatchEvent(new Event('resize'))
      })
    }
  }
}
</script>

<style lang="stylus">
*
  box-sizing: border-box

html, body
  font-family: 'Poppins'
  font-weight: 200

.hero.is-fullheight .hero-body.is-flex-start
  align-items: flex-start;

[class*=hint--]:after
  font-family: 'Poppins' !important;
  font-size: 11px !important;
  font-weight: 400 !important;

.warning-banner
  background-color: #fff4c8;
  font-weight: 400
  font-size: 12px
  position fixed
  top 0px
  left 0px
  width: 100%
  padding 10px 35px
  z-index 1000002
  text-align: center

.hero .tabs ul
  border-bottom 1px
  border-bottom-color #dbdbdb
  border-bottom-style solid
  border-bottom-width 1px

.animate
  animation: colorchange .3s

.animate-long
  animation: colorchange 1.3s

.features
  .feature
    font-size: 14px
// .features-home
//   max-width: 1080px
//   display inline-block
//   .tx-link
//     font-size: 11px
//     display: block;

.features-home
  .features-container
    text-align: center;
    max-width: 720px;
    margin: auto;

.notification
  font-weight: 400;
  
.notification.notice
  margin-bottom: 0px;
  font-size: 12px;
  padding: 1.5rem 1.5rem 1.25rem 1.5rem;
  text-align: left
  font-weight: 300;
  background-color: #fbfbfb;
  p
    margin-bottom: 7.5px;

.notification.is-info.is-info-dark
  background-color: #eaf6ff;
  color: #353535;
  padding: 1.5rem 2.5rem 1.5rem 1.5rem;

.notification.is-warning
  background-color: #fff4c8;

.notification.is-danger
  background-color: #ff7979

.block:not(:last-child), .box:not(:last-child), .breadcrumb:not(:last-child), .content:not(:last-child), .highlight:not(:last-child), .level:not(:last-child), .list:not(:last-child), .message:not(:last-child), .notification:not(:last-child), .progress:not(:last-child), .subtitle:not(:last-child), .table-container:not(:last-child), .table:not(:last-child), .tabs:not(:last-child), .title:not(:last-child)
  margin-bottom: 1rem;

.small-content
  font-size: 13px;
  margin-bottom: 8px;

.notice-container-
  padding 1.5rem 0.5rem 0rem 0.5rem
  text-align: left;
  &.pinned-only
    box-shadow: 0px 0px 0px 1px #efefef;
    border-radius: 15px;
    padding: 0px 15px;
    margin: 15px 0px 30px 0px;
    .notice-content-
      box-shadow none
    .pinned-container
      .notice-content-
        margin-bottom: 10px;
        box-shadow: none;

.result-address .notice-container
  padding 0.5rem 0.5rem 0rem 0.5rem

.result-general
  font-family: Poppins
  font-size: 12px

.separator-circle
  display: inline-block;
  margin: 0px 7.5px 0px 5px;
  height: 5px;
  width: 5px;
  background: #cccccc;
  vertical-align: middle;
  border-radius: 50%;

.w400
  font-weight: 400;

.w600
  font-weight: 600;

.sr-notice
  font-size: 13px;
  font-family: Poppins;
  &.how
    width 100%
  .block
    display: inline-block
    vertical-align: top
    margin-bottom: 0px;
  .block.s-1
    width 60px
    img
      border-radius: 50%;
      width: 50px;
  .block.s-2
    width calc(100% - 60px)
    text-align: left
    padding 0px 0px 0px 20px

.info-miner
  margin-bottom: 0px;
  display inline-block
  font-size 13px
  &.coin-selector
    padding: 20px;
    text-align: center;
    cursor pointer
    color #000
    position relative
    outline none
    &:hover, &:focus, &.pre-selected
      background: #f7f7f7;
      border-radius: 15px;
    hr
      margin: 15px 0px;
    .fees
      font-size: 10px;
      color: #525252;
    img
      width: 40px;
      height: 40px;
      margin-bottom 10px
    .extra-info
      position: absolute;
      left 0
      width: 100%
      margin-top: 5px;
      .tag-
        margin: 0px 2.5px;
        padding: 0px 5px;
        font-weight: 500;
        font-size: 11px;
        display: inline-block;
        &.top-
          background: #97f5e0;
          color: #000;
        &.network-
          background: #5f5f5f;
          color: #fff;
  &.bottom-10
    margin-bottom: 0px;
  &.w100
    width 100%
  .miner-pool
    padding 15px
    font-weight: bold
    border: dashed 2px #efefef;
    font-size: 16px;
    word-break: break-word;
    span
      color:#9e9e9e
    b
      font-family: 'Fredoka one'
      margin: 0px 3px;
  .claymore-example
    font-family: Poppins
    font-size: 13px;
    font-weight: 400;
  .subtitle
    margin-bottom 0px
  .miner-example
    .prev
      opacity: .3;
      pointer-events: none;
    font-family: 'Roboto Mono';
    font-size: 12px;
    font-weight: 200;
    text-align: left;
    padding: 10px 20px;
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px -5px

.is-trx-menu
  font-weight: 600;


    
.tabs li.is-active a
  color: #000;
  border-bottom-color: #000;

.sr-info
  .feature
    font-size: 13px !important
  .big-number
    font-size 35px
    font-weight: bold
  .small-label
    font-size 12px
  .sr-link
    display: inline-block
    margin-top 10px
    font-size: 17px
    height auto
    font-weight: bold;
    .here
      font-size 10px
      display block

.address-info
  width: 100%
  max-width: 1080px
  display inline-block
  .field.has-addons
    width: 100%
  .address-container
    text-align: center;
    max-width: 720px;
    margin: auto;

.social-link
  font-size 16px
  color #000
    
.result-invalid-address, .result-error-address, .result-no-workers, .result-no-votes, .result-maintenance, .result-invalid-memo, .result-no-memo, .result-not-activated, .result-new-address, .result-restricted, .result-payment-warning
  font-family: Poppins
  font-size: 13px

.feature-helvetica
  font-family: Poppins !important

.memo-template-home
  background: #fffeea;
  padding: 25px;
  .miner-pool
    border-color: #dcd995;

.smaller-content
  font-size: 11px;
  margin-bottom: 8px;

.high_risk
  margin-top 5px;
  color: #d99848;
  font-weight: 400;
  
.notice-
  font-size: 13px;
  font-family: Poppins;
  margin-top: 10px;
  margin-bottom: 10px;
  color #000000
  text-align: left
  .indicator-w-pin
    display: inline-block;
    width: 10px;
    height: 10px;
    vertical-align: top;
    margin-right: 10px;
    margin-top: 4px;
    border-radius: 50%;
    &.is-success
      color #97f5e0
    &.is-warning
      color #ffed6c
    &.is-info
      color #99d3ff
    &.is-danger
      color #ff6c6c
    &.is-default
      color: #d7d7d7;
  .indicator
    display: inline-block;
    width: 10px;
    height: 10px;
    vertical-align: top;
    margin-right: 10px;
    margin-top: 7.5px;
    border-radius: 50%;
    &.is-success
      background-color #97f5e0
    &.is-warning
      background-color #ffed6c
    &.is-info
      background-color #99d3ff
    &.is-danger
      background-color #ff6c6c
    &.is-default
      background-color: #d7d7d7;
  .notice-content-
    display: inline-block;
    width: calc(100% - 20px);
    vertical-align: top;
  a
    text-decoration: underline;
    color #000
    font-weight: 400
    cursor pointer
  .time-
    font-size: 11px;
    opacity: .5;
    margin-bottom: 5px;
    font-weight: 400;
  .title-
    margin-bottom: 2.5px;
    font-weight: 400;
  .description-
    font-weight: 100;
    font-size: 12px;

.label-calculate
  font-size: 12px !important;
  margin-bottom: 5px;

.label-info-memo
  padding 5px
  font-size: 12px !important;
  margin-top: -.75rem;

.field-address
  width: 350px;

span.w100
  font-weight: 100;

.slider-
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ccc
  -webkit-transition: .4s
  transition: .4s

.slider-:before
  position: absolute
  content: ""
  height: 11px
  width: 11px
  left: 2px
  bottom: 2px
  background-color: white
  -webkit-transition: .4s
  transition: .4s

input:checked + .slider-
  background-color: #1f9cee

input:focus + .slider-
  box-shadow: 0 0 1px #1f9cee

input:checked + .slider-:before
  -webkit-transform: translateX(11px)
  -ms-transform: translateX(11px)
  transform: translateX(11px)

.slider-.round-
  border-radius: 34px

.slider-.round-:before
  border-radius: 50%

.switch-
  position: relative
  display: inline-block
  width: 26px
  height: 15px
  margin-right: 3px;
  vertical-align: bottom;

.switch- input
  opacity: 0
  width: 0
  height: 0

.button[disabled]
  opacity: 1

.button.is-info[disabled]
  background-color: #92cef7;

.is-disabled
  pointer-events: none;

.position-relative
  position relative

.pink
  /* color #ff84f2 */
  color #fa5dfa

.table-workers tbody, .table-payments tbody, .table-workers-randomx tbody, .table-workers-x16rv2 tbody, .table-workers-etchash tbody
  font-family: Poppins
  font-weight: normal
  font-size 13px
  .bolder
    font-weight: bold
    i
      margin-left: 5px;
  .offline
    opacity .3
  .fa-spin
    color: #ab9f4a;
    font-weight: 100;
  .pending-status
    color: #ab9f4a;
    font-weight: 400
  .completed-status
    color: #4aab71;
    font-weight: 400
  .processing-status
    color: #4a90ab;
    font-weight: 400
  .errored-status
    color: #000;
    font-weight: 400
  .fee-info
    font-size: 9px;
    font-weight: 300;

@media (max-width: 375px)
  .field-address 
    width 300px
    
  .big-info
    width: 100%;
    margin-bottom: 20px;
  
@media (max-width: 450px)
  .big-info.main .pay-block button, .big-info.main .confirm-pay-block button
    margin-bottom: 5px;
  .big-info.main .big-info-number b
    font-size: 35px
  .big-info .big-info-number span
    margin-bottom: 10px;
  .table-payments td.amount, .table-reward-stats td.amount
    font-size: 18px;
  [class*=hint--][aria-label]:after
    display: none
  [class*=hint--][aria-label]:before
    display: none
  .hint--always[aria-label]:after
    display: inherit
  .hint--always[class*=hint--][aria-label]:before
    display: inherit
  // .hint--show-mobile[aria-label]:after
  //   display: inherit
  // .hint--show-mobile[class*=hint--][aria-label]:before
  //   display: inherit
  

@media screen and (max-width: 768px)
  .is-hidden-mobile
    display: none!important;

.referral-template-home {
  background: #f4fff7;
  padding: 25px;
  font-weight: 400;
}
.referral-template-home .miner-pool {
  border-color: #76a57e;
}

.apexcharts-canvas
  color #000;


html.dark, body.dark
  background: #2c2c2c;
  color: #fff;
  transition: all .3s ease;
  .feature
    color: #fff;
  .feature-helvetica
    color: #fff;
  .big-info-number
    color: #fff;
  .info-miner
    color: #fff;
  .text-white-on-dark
    color: #fff;
  .text-black-on-dark
    color: #000;
    &:hover
      color: #000;
  .warning-banner
    color #000
  .notice- .notice-content-
    color #fff
  .mining-guide
    color: #fff;
    border solid 1px #fff
    &:hover
      color: #fff;
      border solid 1px #8e8e8e
  .menu .button
    color: #fff;
  .miner-example-ad, .miner-example-wn
    color: #000;
  .referral-template-home
    color: #000;
    a
      color: #000;
    a:hover
      color: #000;
  .referral-template-home.stats
    background #000
    color: #fff;
    a, a:hover
      color #fff
  .info-miner.coin-selector
    color: #fff;
    outline none
    &:hover, &:focus, &.pre-selected
      background: #000;
      border-radius: 15px;
  .info-miner.coin-selector .extra-info .tag-.network-
    background #dedede
    color: #000;
  .table
    background: #2c2c2c;
    color: #fff;
    transition: all .3s ease;
  .table thead td, .table thead th
    color: #fff;
    transition: all .3s ease;
  .big-info span
    color: #fff;
  .table-workers tbody .errored-status, .table-payments tbody .errored-status, .table-workers-randomx tbody .errored-status, .table-workers-x16rv2 tbody .errored-status, .table-workers-etchash tbody .errored-status
    color: #fff;
  hr
    background-color #414141
  a
    color: #d1d1d1;
  a:hover
    color #fff
  .memo-template-home
    color #000
  .live-summary .item-summary .value
    color #fff
  .pool-box .pool-url:hover
    color #000
  .pool-box .pool-url-port:hover
    color #000
  .button.is-text.is-active, .button.is-text:active
    color #000
  .button.is-text.is-focused, .button.is-text.is-hovered, .button.is-text:focus, .button.is-text:hover
    color #000
  .menu-container .menu-coin .label-
    color #000
  .table td, .table th
    border-color: #616161;
  .notification.notice-.is-success, .notification.notice-.is-default, .notification.notice-.is-warning
    background-color: #666666;
    color: #fff;
  .table-payments.loading:before
    background-color: #2c2c2c;
  .animate
    animation: colorchange-dark .3s
  .animate-long
    animation: colorchange-dark 1.3s
  .menu-container .menu-coin .small-mobile-text
    color #fff
  .tabs.is-boxed li.is-active a, .tabs.is-boxed a:hover
    background-color: #2c2c2c;
    color #fff
  .tabs li.is-active a
    color #fff
  .tab-content.is-loading
    &:after
      content: "Loading...";
      color: #fff;
      background: rgba(44,44,44, .8);
  .balance.is-loading
    &:after
      content: "Loading...";
      color: #fff;
      background: rgba(44,44,44, .8);
  .menu .button.download-top
    color: #000
  .label-calculate
    color: #fff;
  .great-tab
    a
      background-color: #2c2c2c;
      color: #fff;
  .mini-tab
    a
      background-color: #2c2c2c;
      color: #fff;
  .new-tabs-no-boxed .great-tab a
    background-color: #2c2c2c;
    color: #fff;
  .info-link
    text-decoration: underline;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
.noty_body
  font-family: Poppins;
  font-size: 13px;
  padding: 10px;
  text-align: center
.pl-20
  padding-left 20px
.pr-20
  padding-right 20px
.mb-10
  margin-bottom 10px
.pb-5
  padding-bottom 5px
.pt-0
  padding-top 0px
.pt-20
  padding-top 20px
.fs-10
  font-size 10px
.fs-11
  font-size 11px
.fs-12
  font-size 12px
.fs-13
  font-size 13px
.fs-14
  font-size 14px
.fs-15
  font-size 15px
.fs-16
  font-size: 16px
.fs-17
  font-size: 17px
.fs-18
  font-size: 18px
.fs-19
  font-size: 19px
.fs-20
  font-size: 20px
.mr-5
  margin-right: 5px
.ml-5
  margin-left: 5px
.ml-0
  margin-left: 0px
.ml-10
  margin-left: 10px
.mb-0
  margin-bottom: 0px !important
.mb-5
  margin-bottom: 5px
.mb-10
  margin-bottom:10px
.mb-13
  margin-bottom:13px
.mb-15
  margin-bottom:15px
.mb-20
  margin-bottom:20px
.mb-30
  margin-bottom: 30px !important
.mt-2
  margin-top:2px
.mt-3
  margin-top:3px
.mt-5
  margin-top:5px
.mt-10
  margin-top:10px
.mt-13
  margin-top:13px
.mt-15
  margin-top:15px !important
.mt-20
  margin-top:20px !important
.fw-400
  font-weight 400
.mw-300
  max-width 300px
.m-auto
  margin auto
.fw-300
  font-weight 300
.fw-400
  font-weight 400
.fw-700
  font-weight 700
.wb-ba
  word-break: break-all
.opacity-07
  opacity: 0.7
.opacity-05
  opacity: 0.5
.opacity-04
  opacity: 0.4
.ls-1
  letter-spacing: 1px
.pos-r
  position: relative
b.light-bold 
  font-weight 400
.s12
  font-size: 12px
.cursor-pointer
  cursor pointer
.display-none
  display none
.is-flex
  display flex
.flex
  display flex
.flex-1
  flex 1
.fdc
  flex-direction column
.aic
  align-items center
.jcc
  justify-content center
.has-text-justify
  text-align justify !important  
.pointable
  cursor pointer
.has-opacity 
  opacity 0.6

.close-message
  position: absolute;
  top: 4px;
  right: 15px;
  font-size: 20px;
  cursor: pointer;
  color: #bab18c;

.info-link
  text-decoration: underline;
  color: #000;
  font-weight: 400;
  cursor: pointer;

@media (max-width: 985px)
  .hide-less-985
    display none
  .show-less-985
    display flex

// @media (max-width: 550px)
//   .start-info .title-mining
//     // text-align: center
//     line-height: 2.1rem;

@-moz-keyframes colorchange {
  0% {
    background: #fff;
  }
  25% {
    background: #fffad6;
  }
  100% {
    background: #fff;
  }
}
@-webkit-keyframes colorchange {
  0% {
    background: #fff;
  }
  25% {
    background: #fffad6;
  }
  100% {
    background: #fff;
  }
}
@-o-keyframes colorchange {
  0% {
    background: #fff;
  }
  25% {
    background: #fffad6;
  }
  100% {
    background: #fff;
  }
}
@keyframes colorchange {
  0% {
    background: #fff;
  }
  25% {
    background: #fffad6;
  }
  100% {
    background: #fff;
  }
}

@-moz-keyframes colorchange-dark {
  0% {
    background: #2c2c2c;
  }
  25% {
    background: #000;
  }
  100% {
    background: #2c2c2c;
  }
}
@-webkit-keyframes colorchange-dark {
  0% {
    background: #2c2c2c;
  }
  25% {
    background: #000;
  }
  100% {
    background: #2c2c2c;
  }
}
@-o-keyframes colorchange-dark {
  0% {
    background: #2c2c2c;
  }
  25% {
    background: #000;
  }
  100% {
    background: #2c2c2c;
  }
}
@keyframes colorchange-dark {
  0% {
    background: #2c2c2c;
  }
  25% {
    background: #000;
  }
  100% {
    background: #2c2c2c;
  }
}

@-moz-keyframes fadeOutIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes fadeOutIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-o-keyframes fadeOutIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOutIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes rotate {
  to {
    --angle: 360deg;
  } 
}

@property --angle { 
  syntax: '<angle>'; 
  initial-value: 0deg; 
  inherits: false;
}


.fade-enter-active {
  transition: opacity .5s ease;
}

.fade-leave-active {
  transition: opacity 0s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-enter-active {
  transition all .5s ease
}

.slide-leave-active {
  transition all .3s ease
}

.slide-enter-to,
.slide-leave {
  max-height: 700px;
  overflow: hidden;
  opacity 1
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
  opacity 0
}

.top-feature
  font-size 15px
  text-align justify
.bottom-feature
  font-size 15px
  text-align justify
  
.fa-fade {
  -webkit-animation-delay:-1ms;
  animation-delay:-1ms;
  -webkit-animation-duration:1ms;
  animation-duration:1ms;
  -webkit-animation-iteration-count:1;
  animation-iteration-count:1;
  transition-delay:0s;
  transition-duration:0s
}

.fa-fade{
  -webkit-animation-name:fa-fade;
  animation-name:fa-fade;
  -webkit-animation-iteration-count:var(--fa-animation-iteration-count,infinite);
  animation-iteration-count:var(--fa-animation-iteration-count,infinite);
  -webkit-animation-timing-function:var(--fa-animation-timing,cubic-bezier(.4,0,.6,1));
  animation-timing-function:var(--fa-animation-timing,cubic-bezier(.4,0,.6,1))
  -webkit-animation-delay:var(--fa-animation-delay,0);
  animation-delay:var(--fa-animation-delay,0);
  -webkit-animation-direction:var(--fa-animation-direction,normal);
  animation-direction:var(--fa-animation-direction,normal);
  -webkit-animation-duration:var(--fa-animation-duration,1s);
  animation-duration:var(--fa-animation-duration,1s)
}

@-webkit-keyframes fa-fade{
  50%{
      opacity:var(--fa-fade-opacity,.4)
  }
}
@keyframes fa-fade{
  50%{
      opacity:var(--fa-fade-opacity,.4)
  }
}

@media (max-width: 439px)
  .hero-body
    padding 3rem 1rem

@media screen and (min-width: 1472px)
  .container
    max-width: 1080px;
    width: 1080px;

@media screen and (min-width: 1280px)
  .container
    max-width: 1080px;
    width: 1080px;

</style>



// WEBPACK FOOTER //
// App.vue?2a3daf3d